import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Advertiser from './pages/Advertiser';
import ClubsResort from './pages/ClubsResort';
import RevenueManagement from './pages/RevenueManagement';
import OrdersManagement from './pages/OrdersManagement';
import Transactions from './pages/Transactions';
import StaffManagement from './pages/StaffManagement';
import { Toaster } from 'react-hot-toast';
import RouteMiddleware from './middleware';
import { useEffect } from 'react';
import ContactUs from './components/contact-us/ContactUs';
import ExploreClubsRequests from './components/contact-us/ExploreClubsRequests';
import AddClubForm from './components/clubsresort/AddClubForm';
import ClubsResortDetails from './components/clubsresort/ClubsResortDetails';
import AdvertiserDetail from './components/advertiser/AdvertiserDetails';
import OrderDetails from './pages/OrderDetails';
import Coupon from './pages/Coupon';
import NotFound from './pages/NotFound';

function App() {
    useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return (
    <Router>
      <Toaster/>
      <RouteMiddleware>
      <Routes>
        {/* Login Route - No Layout */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

        {/* Protected Routes - With Layout */}
        <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
        <Route path="/advertiser" element={<Layout><Advertiser /></Layout>} />
        <Route path="/advertiser-details/:id" element={<Layout><AdvertiserDetail /></Layout>} />
        <Route path="/clubs-resort" element={<Layout><ClubsResort /></Layout>} />
        <Route path="/clubs-details/:id" element={<Layout><ClubsResortDetails /></Layout>} />
        <Route path="/revenue-management" element={<Layout><RevenueManagement /></Layout>} />
        <Route path="/orders-management" element={<Layout><OrdersManagement /></Layout>} />
        <Route path="/order-details/:id" element={<Layout><OrderDetails /></Layout>}/>
        <Route path="/transactions" element={<Layout><Transactions /></Layout>} />
        <Route path="/coupon" element={<Layout><Coupon /></Layout>} />
        <Route path="/staff-management" element={<Layout><StaffManagement /></Layout>} />
        <Route path="/contact-us" element={<Layout><ContactUs /></Layout>} />
        <Route path="/explore-clubs" element={<Layout><ExploreClubsRequests/></Layout>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      </RouteMiddleware>

    </Router>
  );
}

export default App;
